import axios from 'axios'
import Cookie from './Cookie'
import { setAuthen, setRoles } from '../libs/todoSlice'

export default function logoutRedirect(oauth, prefix = '') {
  if (oauth === true) {
    window.location.href = `${process.env.REACT_APP_ONE_ID}/api/oauth/logout?redirect_url=${process.env.REACT_APP_URL}/${prefix ?? ''}`
  } else {
    window.location.href = `/${prefix}`
  }
}

export const logoutSession = async ({ removeCookie, dispatch, oauth = false, prefix = '', useApiCall = true } = {}) => {
  try {
    if (useApiCall) {
      await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/logout`,
      })
    }
  } catch (error) {
    // Ignore server logout failure; cleanup and redirect still need to happen.
  } finally {
    if (removeCookie) {
      removeCookie('access_token', { path: '/' })
      removeCookie('account', { path: '/' })
      removeCookie('new_user', { path: '/' })
      removeCookie('remember', { path: '/' })
      removeCookie('oauth', { path: '/' })
      removeCookie('oauth_callback', { path: '/' })
    }

    localStorage.removeItem('account')
    localStorage.removeItem('policy_accept')
    localStorage.removeItem('set_service_biz')

    if (dispatch) {
      dispatch(setAuthen({ authen: false }))
      dispatch(setRoles({ roles: [] }))
    }

    Cookie.flush()
    logoutRedirect(true, prefix)
  }
}